module.exports = __webpack_public_path__ + "img/delivery.a98ba179.svg";